import { useContext } from 'react';
import ProjectContext from './ProjectProvider';

export const useProjectContext = () => {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};
